// extracted by mini-css-extract-plugin
module.exports = {"header":"_1wBrh","subTitle":"_31ew8","infoIconContainer":"_3Sb_E","infoIconText":"_3Okoj"};